export interface IDomain {
    departmentId: string
    id: string
    label: string
    masterUrl: string
}

export class DomainData {
    domains: IDomain[]
    constructedDomains: IDomain[]
    constructor(domains: IDomain[]) {
        if (!domains) throw new Error('domains are mandatory in DomainData')
        this.domains = domains
        this.constructedDomains = this.constructDomainMap()
    }

    /* 
    Display an ordered list of domains(order to be decided)
    */
    private constructDomainMap(): IDomain[] {
        return this.domains
    }
}
